<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-header-text">Bulk upload</h2>
    <button mat-icon-button class="close-button" (click)="onCancel()">
      <div class="cros-icon">
        <img src="assets/images/cross-icon.svg" class="cross-icon" />
      </div>
    </button>
  </div>

  <div class="dialog-content">
    <div class="upload-section">
      <div class="custom-stepper">
        <div class="step" [class.active]="isStepActive('upload')">
          <div class="step-circle"></div>
          <div class="step-label">Upload</div>
        </div>
        <div class="step-line" [class.active]="isStepActive('review')"></div>

        <div class="step" [class.active]="isStepActive('review')">
          <div class="step-circle"></div>
          <div class="step-label">Review</div>
        </div>
        <div class="step-line" [class.active]="isStepActive('submit')"></div>

        <div class="step" [class.active]="isStepActive('submit')">
          <div class="step-circle"></div>
          <div class="step-label">Submit</div>
        </div>
      </div>

      <div class="d-grid gap-3" *ngIf="currentStep === 'upload'">
        <div class="instructions-section">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap mb-2"
          >
            <div class="instructions-section-head">
              Following instructions :
            </div>
            <div
              *ngIf="type === 'teacher'"
              (click)="!this.downloadTemplateLoading && this.downloadTemplate()"
            >
              <a
                class="download-button"
                [class.disabled]="this.downloadTemplateLoading"
                download
              >
                {{
                  this.downloadTemplateLoading
                    ? "Downloading..."
                    : "Download template"
                }}
              </a>
            </div>
          </div>
          <ol class="instructions-list">
            <li>Download the template and fill in the details.</li>
            <li>Once completed, upload the file below and click submit.</li>
            <li>
              All fields are mandatory. When answering some of the questions there are dropdown options to assist.
            </li>
          </ol>
        </div>

        <div
          class="school-selection"
          *ngIf="type !== 'teacher' && !teacherMode"
        >
          <div class="selection-row">
            <app-input
              class="form-item school-input"
              style="width: 100%"
              context="Normal"
              label="Select school"
              placeholder="Select school"
              type="select"
              [control]="schoolControl"
              [required]="true"
              [options]="schoolOptions"
              [showAddNew]="true"
              [addNewText]="'Add new school'"
              (addNewClicked)="onAddNewSchool()"
              [customErrorMessages]="{ required: 'Please select a school.' }"
            >
            </app-input>
            <div
              class="download-button-wrapper"
              (click)="!this.downloadTemplateLoading && this.downloadTemplate()"
            >
              <a
                class="download-button"
                [class.disabled]="this.downloadTemplateLoading"
                download
                >{{
                  this.downloadTemplateLoading
                    ? "Downloading..."
                    : "Download template"
                }}</a
              >
            </div>
          </div>
        </div>

        <div class="file-upload-section">
          <div
            class="upload-area"
            [ngClass]="{
              'upload-area-error': fileControl.touched && fileControl.invalid,
              'drag-over': isDragOver,
            }"
            (click)="fileInput.click()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
          >
            <input
              type="file"
              #fileInput
              (change)="onFileSelected($event)"
              accept=".csv, .xlsx"
              hidden
              multiple
            />
            <img class="upload-icon" src="assets/images/file-upload.svg" />
            <p class="upload-text">Drag & drop file or <span>browse</span></p>
            <p class="format-info">Supported formats: CSV, Excel (.xlsx)</p>
          </div>
          <div
            class="error-message"
            *ngIf="
              fileControl.touched &&
              (fileControl.invalid || fileControl.hasError('invalidType'))
            "
          >
            Please upload a CSV file.
          </div>
        </div>

        <div *ngIf="uploadedFiles.length > 0" class="upload-file-section">
          <div class="upload-file-section-head">Uploaded</div>
          <div
            class="upload-file-section-input"
            *ngFor="let file of uploadedFiles; let i = index"
          >
            {{ file.name }}
            <img
              class="upload-icon"
              style="cursor: pointer"
              src="assets/images/delete-icon.svg"
              (click)="removeFile(i)"
            />
          </div>
        </div>
      </div>

      <div
        class="table-section"
        *ngIf="currentStep === 'review' && type === 'teacher'"
      >
        <div>
          <div class="main-head-bulk">
            {{ validateData?.validCount }} out of
            {{ validateData?.validCount + validateData?.invalidCount }}
            records are ready for upload
          </div>
          <div class="second-bulk-head" *ngIf="validateData?.invalidCount > 0">
            {{ validateData?.invalidCount }} records have errors. Please fix
            them before submitting.
          </div>
        </div>

        <div
          [ngClass]="teacherMode ? 'error-container p-0' : 'error-container'"
          *ngIf="validateData?.invalidRecords?.length"
        >
          <div
            class="error-text"
            *ngFor="let record of validateData.invalidRecords; let i = index"
          >
            <span>
              {{ i + 1 }}. {{ record.email }} :
              {{ getCombinedErrors(record.validationErrors) }}
            </span>
          </div>
        </div>

        <div class="note-container">
          <div class="note-text">
            Notes
            <!-- <span class="optional">(optional)</span> -->
          </div>
          <div>
            <textarea
              class="note-input"
              [(ngModel)]="noteText"
              (input)="autoResize($event)"
            ></textarea>
          </div>
        </div>
      </div>

      <div
        class="table-section"
        *ngIf="currentStep === 'review' && type === 'student'"
      >
        <div>
          <div class="main-head-bulk">
            {{ validateData?.validCount }} out of
            {{ validateData?.validCount + validateData?.invalidCount }}
            records are ready for upload
          </div>
          <div class="second-bulk-head" *ngIf="validateData?.invalidCount > 0">
            {{ validateData?.invalidCount }} records have errors. Please fix
            them before submitting.
          </div>
        </div>
        <div
          class="error-container"
          *ngIf="validateData?.invalidRecords?.length"
        >
          <div
            class="error-text"
            *ngFor="let record of validateData.invalidRecords; let i = index"
          >
            <div
              *ngFor="
                let key of getValidationErrorKeys(record.validationErrors)
              "
            >
              <span
                >{{ i + 1 }}. {{ record.email }} :
                {{ record.validationErrors[key] }}</span
              >
            </div>
          </div>
        </div>

        <div class="note-container">
          <div class="note-text">
            Notes
            <!-- <span class="optional">(optional)</span> -->
          </div>
          <div>
            <textarea
              class="note-input"
              [(ngModel)]="noteText"
              (input)="autoResize($event)"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="submit-section" *ngIf="currentStep === 'submit'">
        <!-- Show confirmation message for teacher mode -->
        <div
          class="confirmation-message"
          *ngIf="showConfirmationMessage && teacherMode"
        >
          <div class="confirmation-content">
            <h3 class="confirmation-title">Data Submission Confirmation</h3>
            <div class="confirmation-text">
              <p>
                By completing this form and providing the student's personal
                information, you are agreeing to CSQ and its Construction
                Pathways event partners collecting, storing and using the
                student's personal information for its legally mandated
                purposes, including for statistical and analytical purposes.
              </p>

              <p>
                You agree to indemnify CSQ against any liability for any loss or
                damage suffered in connection with the unauthorised use of their
                personal information by a party other than CSQ.
              </p>

              <p>
                CSQ is committed to protecting the confidentiality, security and
                privacy of personal information held in our records and has in
                place appropriate measures to offer that protection.
              </p>
            </div>

            <!-- <div class="records-summary">
                            <p><strong>Ready to submit: {{validateData?.validCount}} records</strong></p>
                            <p *ngIf="validateData?.invalidCount > 0" class="error-text">
                                {{validateData?.invalidCount}} records have errors and will not be submitted.
                            </p>
                        </div> -->
          </div>
        </div>

        <!-- Show success message after submission -->
        <div class="success-section" *ngIf="!showConfirmationMessage">
          <div>
            <img src="assets/images/success-tick.svg" />
          </div>
          <div class="submit-text">Submitted</div>
          <div class="data-text">All data uploaded successfully</div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="dialog-actions"
    *ngIf="currentStep !== 'submit' || showConfirmationMessage"
  >
    <button class="cancel-button" [disabled]="submitting" (click)="onCancel()">
      Cancel
    </button>
    <button
      class="upload-button"
      (click)="onConfirm()"
      [disabled]="
        (currentStep === 'review' && validateData?.validCount === 0) ||
        submitting
      "
    >
      {{
        submitting
          ? "Submiting..."
          : currentStep === "upload"
            ? "Submit"
            : currentStep === "review"
              ? "Submit " + validateData?.validCount + " records"
              : "Confirm & Submit"
      }}
    </button>
  </div>

  <div
    class="dialog-actions"
    *ngIf="currentStep === 'submit' && !showConfirmationMessage"
  >
    <!-- <button class="cancel-button" (click)="onCancel()">Close</button> -->
  </div>
</div>
